import * as React from "react";
import type { SVGProps } from "react";
const SvgArrowUpLeftSquareContained = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M8.5 14.542v-6m0 0h6m-6 0 6.5 6.5m3 6.558H6A3.6 3.6 0 0 1 2.4 18V6A3.6 3.6 0 0 1 6 2.4h12A3.6 3.6 0 0 1 21.6 6v12a3.6 3.6 0 0 1-3.6 3.6"
    />
  </svg>
);
export default SvgArrowUpLeftSquareContained;
